import React from 'react';

export default function AboutSection() {
  return (
    <div className="py-20 bg-black/20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4 bg-gradient-to-r from-purple-400 to-purple-600 bg-clip-text text-transparent">About Poppy Poker</h2>
          <p className="text-xl text-gray-300">Built by poker players, for poker players</p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h3 className="text-2xl font-semibold mb-4 text-purple-400">Our Mission</h3>
            <p className="text-gray-300 mb-6">
              We believe poker should be about the game, not the logistics. Poppy Poker eliminates the 
              frustration of managing timers, coordinating players, and keeping everyone in sync.
            </p>
            <p className="text-gray-300">
              Our app brings the poker community together by making it easier than ever to find games, 
              stay synchronized, and build lasting connections through the game we all love.
            </p>
          </div>
          <div className="bg-black/40 border border-purple-500/30 rounded-2xl p-8">
            <h4 className="text-xl font-semibold mb-4 text-purple-400">Key Statistics</h4>
            <div className="space-y-4">
              <div className="flex justify-between">
                <span className="text-gray-300">Active Users</span>
                <span className="font-semibold text-purple-400">10,000+</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-300">Games Hosted</span>
                <span className="font-semibold text-purple-400">50,000+</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-300">Countries</span>
                <span className="font-semibold text-purple-400">25+</span>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-black/40 border border-purple-500/30 rounded-2xl p-8">
          <h3 className="text-2xl font-semibold mb-6 text-center text-purple-400">Contact Us</h3>
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h4 className="font-semibold mb-2 text-purple-400">Support</h4>
              <p className="text-gray-300 mb-4">Need help? We're here for you.</p>
              <p className="text-purple-400">support@poppypoker.com</p>
            </div>
            <div>
              <h4 className="font-semibold mb-2 text-purple-400">Business Inquiries</h4>
              <p className="text-gray-300 mb-4">Partnership opportunities and collaborations.</p>
              <p className="text-purple-400">business@poppypoker.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


